module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("1px")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("1px 方案在 VUX 组件内应用广泛，包括 Grid, ButtonTab, XTable, XButton, Cell 等等。"), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n利用 flexbox + 1px 你可以实现复杂的宫格布局。")])]), _vm._v(" "), _c('p', [_vm._v("在你项目的"), _c('code', [_vm._v("App.vue")]), _vm._v("引入，组件内不需要再重复引入。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n@import '~vux/src/styles/1px.less';\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("可用类名：")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("vux-1px-l")]), _vm._v(" 左边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-r")]), _vm._v(" 右边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-t")]), _vm._v(" 上边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-b")]), _vm._v(" 下边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-tb")]), _vm._v(" 上下边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px")]), _vm._v(" 全边框")])]), _vm._v(" "), _c('h2', [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("关闭图标主要应用于弹窗(popup)的左侧关闭按钮。")])]), _vm._v(" "), _c('p', [_vm._v("在你项目的"), _c('code', [_vm._v("App.vue")]), _vm._v("引入，组件内不需要再重复引入。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n@import '~vux/src/styles/close.less';\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("可用类名：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("vux-close")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux-close\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("可以参考 "), _c('code', [_vm._v("XDialog")]), _vm._v(" 演示。")]), _vm._v(" "), _c('p', [_vm._v("当你想设置图标颜色时，直接设置 color 即可。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux-close\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"color:red;\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43c99d91", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-43c99d91"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/css-3.vue
// module id = 2195
// module chunks = 453